import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "../initialState.js";
import {
  addCar,
  // assignClientToCar,
  createCarWithoutClient,
  createClient,
  createNewClient,
  createNotification,
  deleteCar,
  deleteClient,
  getClientInfo,
  getClientsList,
  getRepairHistory,
  getRoadmapHistory,
  updateCar,
  updateClient,
} from "./operations.js";

const handlePending = state => {
  state.isLoading = true;
  state.error = null;
};

const handleRejected = (state, action) => {
  state.isLoading = false;
  state.error = action.payload;
};

const clientsSlice = createSlice({
  name: "clients",
  initialState: initialState.clients,
  reducers: {
    clearClientInfo: state => {
      state.clientInfo.client = null;
      state.clientInfo.car = null;
      state.clientInfo.service_history = [];
      state.clientInfo.client_cars = [];
      state.carRepairHistory = [];
      state.roadmapHistory = [];
      state.error = null;
      state.isLoading = false;
    },
    clearRepairHistory: state => {
      state.carRepairHistory = [];
      state.error = null;
      state.isLoading = false;
    },
    clearCarWithoutClient: state => {
      state.carWithoutClient = {};
      state.isLoading = false;
      state.error = null;
    },
  },
  extraReducers: builder =>
    builder
      // Get list of existing clients +
      .addCase(getClientsList.pending, state => {
        state.clientsListLoading = true;
        state.error = null;
      })
      .addCase(getClientsList.fulfilled, (state, action) => {
        state.clientsListLoading = false;
        state.clientsList = action.payload;
      })
      .addCase(getClientsList.rejected, (state, action) => {
        state.clientsListLoading = false;
        state.error = action.payload;
      })

      // Create new client +
      .addCase(createNewClient.pending, handlePending)
      .addCase(createNewClient.fulfilled, (state, action) => {
        state.isLoading = false;
        state.clientsList.push(action.payload);
      })
      .addCase(createNewClient.rejected, handleRejected)

      // Delete client +
      .addCase(deleteClient.pending, handlePending)
      .addCase(deleteClient.fulfilled, (state, action) => {
        state.isLoading = false;
        state.clientsList = state.clientsList.filter(
          client => client.id !== action.payload.id
        );
      })
      .addCase(deleteClient.rejected, handleRejected)

      // Get client detailed info - НОВА АРІ +
      .addCase(getClientInfo.pending, handlePending)
      .addCase(getClientInfo.fulfilled, (state, action) => {
        state.isLoading = false;

        state.clientInfo.client = action.payload.client;
        state.clientInfo.car = action.payload.car;
        state.clientInfo.service_history = action.payload.repair_history;
        state.clientInfo.client_cars = action.payload.client_cars;
        state.clientInfo.repair_id = action.payload.repair_id;
      })
      .addCase(getClientInfo.rejected, handleRejected)

      // Get repair history +
      .addCase(getRepairHistory.pending, handlePending)
      .addCase(getRepairHistory.fulfilled, (state, action) => {
        state.isLoading = false;
        state.carRepairHistory = action.payload;
      })
      .addCase(getRepairHistory.rejected, handleRejected)

      // Get roadmap history +
      .addCase(getRoadmapHistory.pending, state => {
        state.roadmapHistoryLoading = true;
        state.error = null;
      })
      .addCase(getRoadmapHistory.fulfilled, (state, action) => {
        state.roadmapHistoryLoading = false;
        const { recordId } = action.meta.arg;
        state.roadmapHistory = [
          ...state.roadmapHistory.filter(entry => entry.record_id !== recordId),
          ...action.payload,
        ];
      })
      .addCase(getRoadmapHistory.rejected, (state, action) => {
        state.roadmapHistoryLoading = false;
        state.error = action.payload;
      })

      // Create new client and assign him to the Record +
      .addCase(createClient.pending, state => {
        // без isLoading, щоб не розмонтувати ClientInfo разом з модалкою
        state.error = null;
      })
      .addCase(createClient.fulfilled, (state, action) => {
        state.isLoading = false;
        // state.clientInfo.client = action.payload;
      })
      .addCase(createClient.rejected, handleRejected)

      // Update Client +
      .addCase(updateClient.pending, handlePending)
      .addCase(updateClient.fulfilled, (state, action) => {
        state.isLoading = false;
        const clientIndexToUpdate = state.clientsList.findIndex(
          client => client.id === action.payload.id
        );

        if (clientIndexToUpdate !== -1) {
          state.clientsList[clientIndexToUpdate] = {
            ...state.clientsList[clientIndexToUpdate],
            ...action.payload,
          };
        }

        state.clientInfo.client = {
          ...state.clientInfo.client,
          ...action.payload,
        };

        // state.clients.clientInfo.client = action.payload;
      })
      .addCase(updateClient.rejected, handleRejected)

      // add car +
      .addCase(addCar.pending, handlePending)
      .addCase(addCar.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(addCar.rejected, handleRejected)

      // update car +
      .addCase(updateCar.pending, handlePending)
      .addCase(updateCar.fulfilled, (state, action) => {
        state.isLoading = false;
        state.clientInfo.client_cars = state.clientInfo.client_cars.map(car =>
          car.id === action.payload.id
            ? { ...car, ...action.payload } // Оновлюємо тільки змінені поля
            : car
        );
        // state.clients.clientInfo.client = action.payload;
      })
      .addCase(updateCar.rejected, handleRejected)

      .addCase(deleteCar.pending, handlePending)
      .addCase(deleteCar.fulfilled, (state, action) => {
        state.isLoading = false;
        // state.clientInfo.client_cars = state.clientInfo.client_cars.map((car) =>
        //   car.id === action.payload.car_id
        //     ? { ...car, status: "archive", comment: action.payload.comment }
        //     : car
        // );

        // state.clientInfo.client_cars = state.clientInfo.client_cars.filter(
        //   (car) => car.status !== "archive"
        // );

        state.clientInfo.client_cars = state.clientInfo.client_cars.filter(
          car => car.id !== action.payload.car_id
        );
      })
      .addCase(deleteCar.rejected, handleRejected)

      .addCase(createNotification.pending, handlePending)
      .addCase(createNotification.fulfilled, (state, action) => {
        state.isLoading = false;
        // state.clients.clientInfo.client = action.payload;
      })
      .addCase(createNotification.rejected, handleRejected)

      // Assign client to the car
      // .addCase(assignClientToCar.pending, handlePending)
      // .addCase(assignClientToCar.fulfilled, (state, action) => {
      //   state.isLoading = false;
      // })
      // .addCase(assignClientToCar.rejected, handleRejected)

      // Create car without client
      .addCase(createCarWithoutClient.pending, handlePending)
      .addCase(createCarWithoutClient.fulfilled, (state, action) => {
        state.isLoading = false;
        state.carWithoutClient = {
          car_id: action.payload.car_id,
          ...action.meta.arg,
        };
      })
      .addCase(createCarWithoutClient.rejected, handleRejected),
});

export const { clearClientInfo, clearRepairHistory, clearCarWithoutClient } =
  clientsSlice.actions;
export default clientsSlice.reducer;
